/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestResponse from '../model/BadRequestResponse';
import ErrorResponse from '../model/ErrorResponse';
import HydroSystemStatus from '../model/HydroSystemStatus';
import InlineObject from '../model/InlineObject';
import Message from '../model/Message';
import UnprocessableEntityResponse from '../model/UnprocessableEntityResponse';

/**
* Sensors service.
* @module api/SensorsApi
* @version 1.1.0
*/
export default class SensorsApi {

    /**
    * Constructs a new SensorsApi. 
    * @alias module:api/SensorsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getSpecifiedControllerStatus operation.
     * @callback module:api/SensorsApi~getSpecifiedControllerStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HydroSystemStatus} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get status for a specified Fire Controller by ID
     * Gets all statuses including the System Status, all Sensor's statuses, and all Relay's statuses for the specified Fire Controller. The authenticated user must be associated with the Fire Controller.
     * @param {String} fireControllerId The unique ID of the Fire Controller
     * @param {module:api/SensorsApi~getSpecifiedControllerStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HydroSystemStatus}
     */
    getSpecifiedControllerStatus(fireControllerId, callback) {
      let postBody = null;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling getSpecifiedControllerStatus");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = HydroSystemStatus;
      return this.apiClient.callApi(
        '/sensors/status/{fireControllerId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTheSensorStatus operation.
     * @callback module:api/SensorsApi~updateTheSensorStatusCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Message} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the sensor status
     * Updates all statuses including the System Status, all Sensor's statuses, and all Relay's statuses. The systemId is extracted from the HydroSystemStatus payload.
     * @param {module:model/HydroSystemStatus} hydroSystemStatus The Sensor, Relay, and System data to update to
     * @param {module:api/SensorsApi~updateTheSensorStatusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Message}
     */
    updateTheSensorStatus(hydroSystemStatus, callback) {
      let postBody = hydroSystemStatus;
      // verify the required parameter 'hydroSystemStatus' is set
      if (hydroSystemStatus === undefined || hydroSystemStatus === null) {
        throw new Error("Missing the required parameter 'hydroSystemStatus' when calling updateTheSensorStatus");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Message;
      return this.apiClient.callApi(
        '/sensors/status', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
